import { Link } from 'react-router-dom';

export default function InnerFooter() {
  return (
    <footer className="bg-gradient-to-br from-slate-50 via-white to-slate-50 text-slate-800 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-3 gap-16 mb-16">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img
                src="https://storage.readdy-site.link/project_files/70b7a5e7-167c-457e-ada5-3921d7ed109f/d7142fa2-ba05-4d52-830b-5f6de0d95291_city_to_city_logo.png?v=e696fa2f2c1d4156b71769d9a75c094b"
                alt="City to City Moving Company"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-slate-600 mb-8 leading-relaxed text-base">
              Your trusted moving partner in Southern California. We treat your belongings like our own and make every move a smooth, stress-free experience.
            </p>
            <div className="flex flex-wrap gap-3 mb-8">
              <div className="bg-emerald-50 text-emerald-700 px-4 py-2 rounded-lg text-sm font-semibold border border-emerald-200">
                <i className="ri-shield-check-line mr-1"></i>Licensed
              </div>
              <div className="bg-sky-50 text-sky-700 px-4 py-2 rounded-lg text-sm font-semibold border border-sky-200">
                <i className="ri-shield-star-line mr-1"></i>Insured
              </div>
              <div className="bg-amber-50 text-amber-700 px-4 py-2 rounded-lg text-sm font-semibold border border-amber-200">
                <i className="ri-star-line mr-1"></i>20+ Years
              </div>
            </div>
            <div className="flex gap-3">
              {[
                { href: 'https://www.facebook.com', icon: 'ri-facebook-fill' },
                { href: 'https://www.instagram.com', icon: 'ri-instagram-line' },
                { href: 'https://www.x.com', icon: 'ri-twitter-x-line' },
              ].map((s) => (
                <a key={s.href} href={s.href} target="_blank" rel="noopener noreferrer"
                  className="w-11 h-11 flex items-center justify-center bg-slate-900 hover:bg-amber-500 text-white rounded-xl transition-all duration-300 hover:-translate-y-0.5">
                  <i className={`${s.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links + Services */}
          <div className="lg:col-span-1 grid sm:grid-cols-2 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-6 text-slate-900 flex items-center gap-2">
                <i className="ri-links-line text-amber-500"></i>Quick Links
              </h3>
              <ul className="space-y-3">
                {[
                  { label: 'Home', to: '/' },
                  { label: 'Services', to: '/services' },
                  { label: 'About Us', to: '/about' },
                  { label: 'Locations', to: '/locations' },
                ].map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-slate-600 hover:text-amber-600 transition-colors flex items-center gap-2 group">
                      <i className="ri-arrow-right-s-line text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                      <span>{l.label}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <a href="/#quote-form" className="text-slate-600 hover:text-amber-600 transition-colors flex items-center gap-2 group">
                    <i className="ri-arrow-right-s-line text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                    <span>Get Free Quote</span>
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-bold mb-6 text-slate-900 flex items-center gap-2">
                <i className="ri-service-line text-amber-500"></i>Our Services
              </h3>
              <ul className="space-y-3 text-slate-600">
                {['Local Moving', 'Long Distance', 'Commercial Moving', 'Packing Services', 'Loading & Unloading', 'Specialty Items'].map((s) => (
                  <li key={s} className="flex items-start gap-2">
                    <i className="ri-checkbox-circle-fill text-amber-500 mt-0.5 flex-shrink-0"></i>
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold mb-6 text-slate-900 flex items-center gap-2">
              <i className="ri-customer-service-2-line text-amber-500"></i>Contact Us
            </h3>
            <div className="mb-6">
              <div className="text-sm font-semibold text-slate-500 mb-3 uppercase tracking-wide">Call Us Anytime</div>
              <div className="space-y-2">
                <a href="tel:7606257767"
                  className="flex items-center gap-3 bg-gradient-to-r from-slate-900 to-slate-800 text-white px-4 py-3 rounded-xl hover:from-amber-500 hover:to-amber-600 transition-all duration-300">
                  <i className="ri-phone-fill text-xl"></i>
                  <span className="font-bold text-lg">(760) 625-7767</span>
                </a>
                <a href="tel:5624553028"
                  className="flex items-center gap-3 bg-slate-100 text-slate-800 px-4 py-3 rounded-xl hover:bg-amber-50 hover:text-amber-700 transition-all duration-300 border border-slate-200">
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">(562) 455-3028</span>
                </a>
                <a href="tel:7603472727"
                  className="flex items-center gap-3 bg-slate-100 text-slate-800 px-4 py-3 rounded-xl hover:bg-amber-50 hover:text-amber-700 transition-all duration-300 border border-slate-200">
                  <i className="ri-phone-line text-xl"></i>
                  <span className="font-semibold">(760) 347-2727</span>
                </a>
              </div>
            </div>
            <div className="mb-6">
              <div className="text-sm font-semibold text-slate-500 mb-2 uppercase tracking-wide">Service Area</div>
              <div className="text-slate-700 font-medium">Southern California</div>
              <div className="text-slate-600 text-sm">Irvine &bull; Indio &bull; Newport Beach &bull; Long Beach</div>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 border border-amber-200 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-2">
                <i className="ri-time-line text-amber-600 text-xl"></i>
                <div className="text-sm font-semibold text-amber-900 uppercase tracking-wide">Business Hours</div>
              </div>
              <div className="text-slate-800 font-bold">Monday - Sunday</div>
              <div className="text-slate-700">9:00 AM - 5:00 PM</div>
              <div className="flex items-center gap-2 text-emerald-700 text-sm mt-2 font-medium">
                <i className="ri-checkbox-circle-fill"></i>
                <span>Same-day service available</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-slate-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-slate-600 text-sm text-center md:text-left">
              &copy; 2026 City to City Moving Company. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-slate-600 hover:text-amber-600 transition-colors">Privacy Policy</a>
              <a href="#" className="text-slate-600 hover:text-amber-600 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
